module.exports = __webpack_public_path__ + "media/images/markup-images/noukaweb-logo-4x3-7d0b6820fe7cf8150613c006ea2d80ee.jpg";